import { render, staticRenderFns } from "./AssociationPreview.vue?vue&type=template&id=2a3f7eb0"
import script from "./AssociationPreview.vue?vue&type=script&lang=js"
export * from "./AssociationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports